import { MediaType } from '@business/entities/media';
import { FileService } from '../file_service';

export function getMediaTypes() {
  return [MediaType.url, MediaType.file];
}

export function canView(filename: string) {
  if (FileService.isImage(filename)) {
    return true;
  } else if (FileService.isGoogleDocs(filename)) {
    return true;
  } else if (FileService.isVideo(filename)) {
    return true;
  }
  return false;
}

export function isYoutubeLink(url: string) {
  return url.indexOf('youtube.com') > -1;
}

export function isVimeoLink(url: string) {
  return url.indexOf('vimeo') > -1;
}
